import React, { useCallback, useEffect, useState } from "react";
import { ModuleSection, OnboardingTrainingModuleType, StatusEnum } from "./type";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import CheckIcon from "@mui/icons-material/Check";
import ListItemText from "@mui/material/ListItemText";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import arrowRight from "../../assets/img/arrow-right.png";
import {
  completeBoxMarginStyle,
  completeBoxStyle,
  completeIconStyle,
  subheader,
  sectionItem,
  item,
} from "./style";
import { useNavigate, useNavigation } from "react-router-dom";
import { ONBOARDING_PATH, ROOT_PATH } from "../../../../routes/constants";
import style from "./style.module.css";
import { ListSubheader } from "@mui/material";
import { color } from "../../../../mui-theme/palette";
import { useQuery } from "../../../../utils/hooks/use-query";
import { PruToast } from "../../../../components/pru-toast";
import { getI18n } from "react-i18next";
import { OnboardingApplicationStatus, RoleEnum } from "../../types";
import { getToken, parseJwt } from "../../utils";

type TrainingMenuListProps = {
  sections?: ModuleSection[];
  npaNumber?: string;
  candidateOnboarding?: any;
};

export const TrainingMenuList = (props: TrainingMenuListProps) => {
  const { sections = [], npaNumber, candidateOnboarding } = props;
  const navigate = useNavigate();
  const query = useQuery();
  const rawToken = getToken();
  const tokenData = rawToken ? parseJwt(rawToken) : {};
  const progressExamRegistration = candidateOnboarding?.examRegistration?.step == 2 ?
  candidateOnboarding?.examRegistration?.aaji && candidateOnboarding?.examRegistration?.aasi ? 'completed' : 'editing' : 'untouched';

  return (
    <div
      className={`${style["list-container"]} ${style.flex1} ${style["flex-column"]} ${style.padding}`}
    >
      <List>
        {sections.map((section) => {
          return (
            <div key={section.name} className={`${style.item}`}>
              <ListSubheader sx={subheader}>
                <ListItemButton
                  onClick={() => {
                    if(candidateOnboarding.applicationStatus == OnboardingApplicationStatus.CANCELLED || candidateOnboarding.applicationStatus == OnboardingApplicationStatus.REJECTED || candidateOnboarding.applicationStatus == OnboardingApplicationStatus.EXPIRED){
                      if(tokenData.role == RoleEnum.CANDIDATE){
                        PruToast({
                          message: getI18n().t(`onboarding.message_check_step_with_status_${candidateOnboarding.applicationStatus.toLowerCase()}_candidate`),
                          duration: 2000,
                        });
                        return false;
                      }else{
                        PruToast({
                          message: getI18n().t(`onboarding.message_check_step_with_status_${candidateOnboarding.applicationStatus.toLowerCase()}_recruiter`),
                          duration: 2000,
                        });
                        return false;
                      }
                    }
                    switch (section.name) {
                      case OnboardingTrainingModuleType.Training: {
                        if (section.status === StatusEnum.disabled) {
                          PruToast({
                            message: getI18n().t("please_complete_application_modules"),
                          });
                        } else {
                          navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/courses?${query.toString()}`);
                        }
                        break;
                      }
                      case OnboardingTrainingModuleType.ExamRegistration: {
                        if (
                          [StatusEnum.disabled, StatusEnum.completedButDisabled].includes(
                            section.status as any,
                          )
                        ) {
                          PruToast({
                            message: getI18n().t("please_complete_onboarding_module"),
                          });
                        } else {
                          if(section.name == 'license_exam_registration'){
                            query.set("npaNumber", npaNumber || "");
                            navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/exams/registry-plai?${query.toString()}`,{
                              state: {candidateOnboarding}
                            });
                          }else{
                            navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/exams?${query.toString()}`);
                          }
                        }
                        break;
                      }
                    }
                  }}
                >
                  {[StatusEnum.completed, StatusEnum.completedButDisabled].includes(
                    section.status as any,
                  ) ? (
                    <Box sx={completeBoxMarginStyle}>
                      <CheckIcon sx={completeIconStyle} />
                    </Box>
                  ) : (
                    <ListItemText
                      sx={sectionItem}
                      primary={`(${section.numerator}/${section.denominator})`}
                    />
                  )}
                  <ListItemText primary={section.title} />
                  {
                    section.name == "license_exam_registration" &&
                    candidateOnboarding?.examRegistration?.step == 2 &&
                    progressExamRegistration != 'completed' &&
                    <StatusIcon status={progressExamRegistration}></StatusIcon>
                  }
                </ListItemButton>
              </ListSubheader>
            </div>
          );
        })}
      </List>
    </div>
  );
};

const StatusIcon = ({ status }: { status?: keyof typeof StatusEnum }) => {
  switch (status) {
    case StatusEnum.completed:
      return (
        <Box sx={completeBoxStyle}>
          <CheckIcon sx={completeIconStyle} />
        </Box>
      );
    case StatusEnum.editing:
      return <img src={arrowRight} alt="banner"></img>;
    case StatusEnum.untouched:
      return <ChevronRightIcon />;
  }
  return <></>;
};
